<script setup>
import BaseModal from '@dogfy/components/base/BaseModal.vue'

const isOpen = defineModel({ type: Boolean, default: false })
</script>

<template>
  <BaseModal
    v-model="isOpen"
    :has-primary-button="false"
    :has-secondary-button="false"
    size="medium"
  >
    <div class="storage-popup">
      <div class="storage-popup__image-container">
        <img class="storage-popup__image" src="/figures/dodi/dodi-yellow-monocle.svg?url" :alt="$t('common.label.monocleImageAlt')">
      </div>
      <p class="storage-popup__title">
        {{ $t('common.label.bestExperienceOffer') }}
      </p>
      <p class="storage-popup__description">
        {{ $t('common.message.storageUnavailable') }}
      </p>
    </div>
  </BaseModal>
</template>

<style lang="scss">
.storage-popup {
  display: flex;

  flex-direction: column;
  align-items: center;

  padding: $spacer;

  text-align: center;

  &__image-container {
    margin-bottom: $spacer*1.5;
    width: 136px;
    height: 136px;

    @include breakpoint(md) {
      width: 184px;
      height: 184px;
    }
  }

  &__image {
    width: 100%;
    height: 100%;
  }

  &__title {
    margin-bottom: $spacer;

    font-size: ms(1, true);
    line-height: $font-lineheight-large;
    font-weight: $font-weight-semibold;
    color: $color-neutral-darkest;
  }

  &__description {
    margin-bottom: $spacer;

    font-size: ms(0, true);
    line-height: $font-lineheight-large;
    font-weight: $font-weight-regular;
    color: $color-neutral-darkest;
  }
}
</style>
